import Vue from 'vue'
import Router from 'vue-router'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _0faef30f = () => interopDefault(import('../../../pages/blog/index.vue' /* webpackChunkName: "pages/blog/index" */))
const _2cb4b33a = () => interopDefault(import('../../../pages/bookkeeping.vue' /* webpackChunkName: "pages/bookkeeping" */))
const _563021e8 = () => interopDefault(import('../../../pages/branch.vue' /* webpackChunkName: "pages/branch" */))
const _819dea40 = () => interopDefault(import('../../../pages/consulting.vue' /* webpackChunkName: "pages/consulting" */))
const _66373cb6 = () => interopDefault(import('../../../pages/consulting-complete.vue' /* webpackChunkName: "pages/consulting-complete" */))
const _7cc4ed0e = () => interopDefault(import('../../../pages/consulting-detail.vue' /* webpackChunkName: "pages/consulting-detail" */))
const _3f41b0a6 = () => interopDefault(import('../../../pages/customer-review.vue' /* webpackChunkName: "pages/customer-review" */))
const _0e294e50 = () => interopDefault(import('../../../pages/heum-people/index.vue' /* webpackChunkName: "pages/heum-people/index" */))
const _6c1f552d = () => interopDefault(import('../../../pages/heum-system.vue' /* webpackChunkName: "pages/heum-system" */))
const _1209af31 = () => interopDefault(import('../../../pages/offline-lead-form.vue' /* webpackChunkName: "pages/offline-lead-form" */))
const _4bc1e3f0 = () => interopDefault(import('../../../pages/privacy-statement.vue' /* webpackChunkName: "pages/privacy-statement" */))
const _5156604e = () => interopDefault(import('../../../pages/privacy-statement-210112.vue' /* webpackChunkName: "pages/privacy-statement-210112" */))
const _391e9ca0 = () => interopDefault(import('../../../pages/terms-of-marketing.vue' /* webpackChunkName: "pages/terms-of-marketing" */))
const _a809eba2 = () => interopDefault(import('../../../pages/terms-of-service.vue' /* webpackChunkName: "pages/terms-of-service" */))
const _0c72ad08 = () => interopDefault(import('../../../pages/heum-people/_slug.vue' /* webpackChunkName: "pages/heum-people/_slug" */))
const _0547af50 = () => interopDefault(import('../../../pages/index.vue' /* webpackChunkName: "pages/index" */))

// TODO: remove in Nuxt 3
const emptyFn = () => {}
const originalPush = Router.prototype.push
Router.prototype.push = function push (location, onComplete = emptyFn, onAbort) {
  return originalPush.call(this, location, onComplete, onAbort)
}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: decodeURI('/'),
  linkActiveClass: 'navigation__link--active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/blog",
    component: _0faef30f,
    name: "blog"
  }, {
    path: "/bookkeeping",
    component: _2cb4b33a,
    name: "bookkeeping"
  }, {
    path: "/branch",
    component: _563021e8,
    name: "branch"
  }, {
    path: "/consulting",
    component: _819dea40,
    name: "consulting"
  }, {
    path: "/consulting-complete",
    component: _66373cb6,
    name: "consulting-complete"
  }, {
    path: "/consulting-detail",
    component: _7cc4ed0e,
    name: "consulting-detail"
  }, {
    path: "/customer-review",
    component: _3f41b0a6,
    name: "customer-review"
  }, {
    path: "/heum-people",
    component: _0e294e50,
    name: "heum-people"
  }, {
    path: "/heum-system",
    component: _6c1f552d,
    name: "heum-system"
  }, {
    path: "/offline-lead-form",
    component: _1209af31,
    name: "offline-lead-form"
  }, {
    path: "/privacy-statement",
    component: _4bc1e3f0,
    name: "privacy-statement"
  }, {
    path: "/privacy-statement-210112",
    component: _5156604e,
    name: "privacy-statement-210112"
  }, {
    path: "/terms-of-marketing",
    component: _391e9ca0,
    name: "terms-of-marketing"
  }, {
    path: "/terms-of-service",
    component: _a809eba2,
    name: "terms-of-service"
  }, {
    path: "/heum-people/:slug?",
    component: _0c72ad08,
    name: "heum-people-slug"
  }, {
    path: "/",
    component: _0547af50,
    name: "index"
  }],

  fallback: false
}

export function createRouter () {
  return new Router(routerOptions)
}
